export default class AMatterSprite extends Phaser.Physics.Matter.Sprite
{
    constructor(scene, x, y, animation)
    {
        super(scene.matter.world, x, y, animation, null, {
            friction: 0.005, 
            restitution: 0.6,
            density: 1 
        });

        if(animation != null) this.anims.play(animation);

        this.animation = animation;
        this.curFrameIdx = 0;
        this.frameListeners = [];

        this.playing = false;
        this.inReverse = false;
    }

    stop()
    {
        this.shadow.anims.stop();
        this.anims.stop();
    }

    destroy()
    {
        let i = this.frameListeners.length;
        while(i)
        {
            i--;
            let n = this.frameListeners[i].listeners.length;
            while(n)
            {
                n--;
                this.frameListeners[i].listeners.pop();
                
            }
            this.frameListeners[i].listeners = null;
            delete this.frameListeners[i].listeners;

            this.frameListeners.pop();
        }

        super.destroy();
    }

    addListenerToFrame(frameIndex, listener, animationName = null)
    {
        let animation = animationName == null ? this.anims.currentAnim : this.anims.animationManager.anims.entries[animationName];
        if(frameIndex < 0 || frameIndex >= animation.frames.length)
        {
            console.warn("Frame index: " + frameIndex + " of animation: " + animation.key + " does not exist.");
            return;
        }
        if(animation.frames[frameIndex].listeners == null) 
        {
            animation.frames[frameIndex].listeners = [];
            this.frameListeners.push(animation.frames[frameIndex]);
        }
        animation.frames[frameIndex].listeners.push(listener);
    }

    setFrameIndex(index)
    {
        this.anims.setCurrentFrame(this.anims.currentAnim.frames[index]);
        this.curFrameIdx = index;
    }

    play(animation, ignoreIfPlaying = false, startIdx = null)
    {
        let idx = startIdx ? startIdx : this.curFrameIdx;

        this.anims.play(animation, ignoreIfPlaying, idx);
        if(this.shadow) this.shadow.anims.play(animation, ignoreIfPlaying, idx);

        this.setFrameIndex(idx);
    }

    playReverse(animation, ignoreIfPlaying = false, startIdx = null)
    {
        let idx = startIdx ? startIdx : this.curFrameIdx;

        this.anims.playReverse(animation, ignoreIfPlaying, idx);
        if(this.shadow) this.shadow.anims.playReverse(animation, ignoreIfPlaying, idx);

        this.setFrameIndex(idx);
    }

    preUpdate(time, delta)
    {
        super.preUpdate(time, delta);

        if(!this.anims) return;

        let frame = this.anims.currentFrame;
        if(frame.index != this.curFrameIdx)
        {
            this.curFrameIdx = frame.index;
            if(frame.listeners)
            {
                let iters = frame.listeners.length;
                for(let i = 0; i < iters; i++) frame.listeners[i]();
            }
        }
    }

}